import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ILoggerNoiseSpectrumChartData } from '@app/api/interfaces/chart-data/logger-noise-spectrum';
import { ILoggerNoiseHistogramChartData } from '@app/api/interfaces/chart-data/logger-noise-histogram';

@Injectable({
  providedIn: 'root',
})
export class LoggerMeasurementChartDataApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getSignalSpectrum(
    projectId: string,
    measurementId: string
  ): Observable<IApiResponse<ILoggerNoiseSpectrumChartData, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${measurementId}/chart-data/signal-spectrum`;

    return this.httpClient.get<IApiResponse<ILoggerNoiseSpectrumChartData, object>>(url, {
      withCredentials: true,
    });
  }

  public getHistogram(
    projectId: string,
    measurementId: string
  ): Observable<IApiResponse<ILoggerNoiseHistogramChartData, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${measurementId}/chart-data/histogram`;

    return this.httpClient.get<IApiResponse<ILoggerNoiseHistogramChartData, object>>(url, {
      withCredentials: true,
    });
  }
}
